<template>
  <div class="profil-container">
    <h3 class="profil-title">Halaman Pengisian Data Vendor</h3>
    <p class="profil-subtitle">Silahkan mengisi data sesuai kolom di bawah</p>

    <div class="vendor-form-wrapper">
      <input-doc :label="'Perizinan'" :modelName="'addedPerizinan'" :isRequired="false"
        :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :modalName="'modal_add_perizinan'"
        :disabled="true" />
      <input-select-table :label="'Bidang Usaha Pertambangan Inti'" :tables="[
        {
          name: 'Jenis',
          obj_name: 'jenis',
          css: 'column10 mr10',
        },
        {
          name: 'Bidang',
          obj_name: 'bidang',
          css: 'column40',
        },
        {
          name: 'Sub Bidang',
          obj_name: 'sub_bidang',
          css: 'column40',
        },
      ]" :modelName="'addedIUJP'" :isRequired="false" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
        :modalName="'modal_add_iujp'" :disabled="true" />
      <input-fill-form :label="'Bidang Usaha Pertambangan Non Inti'" :tables="[
        {
          name: 'Bidang',
          obj_name: 'desc',
          css: 'column30 mr10 all-column',
          input: false,
          type: '',
        },
        {
          name: 'Penjelasan',
          obj_name: 'penjelasan',
          css: 'column70',
          input: true,
          type: 'text',
        },
      ]" :isRequired="false" :modalName="'modal_add_iujp_non_inti'" :modelName="'addedIUJPnonInti'"
        :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
        :disabled="$store.state.k3lStore.is_sipm_approved" />
      <input-upload :label="'Lampiran dokument Struktur Organisasi Perusahaan (Posisi/Jabatan & Nama Pekerja)'
        " :modelName="'structurOrgFile'" :isRequired="false" :mutationName="'k3lStore/SET_K3L_FORM'"
        :storeName="'k3lStore'" :docId="1" :is_single="true" :disabled="$store.state.k3lStore.is_sipm_approved" />
      <input-fill-form :label="'Isi tabel daftar karyawan yang memiliki sertifikat kompetensi K3 dan atau kompetensi khusus sesuai jabatan dan bidangnya'
        " :tables="[
    {
      name: 'Posisi',
      obj_name: 'posisi',
      css: 'column20',
      input: false,
      type: '',
    },
    {
      name: 'Jumlah Karyawan',
      obj_name: 'jumlah',
      css: 'column20 mr10 all-column',
      input: false,
      type: '',
    },
    {
      name: 'Kompetensi Umum / Khusus',
      obj_name: 'umum_khusus',
      css: 'column20 mr10 all-column',
      input: false,
      type: '',
    },
    {
      name: 'Pengalaman Kerja (Tahun)',
      obj_name: 'pengalaman_kerja',
      css: 'column20 mr10 all-column',
      input: false,
      type: '',
    },
    {
      name: 'Dokumen Pendukung',
      obj_name: 'sertifikat_karyawan',
      css: 'column20 mr10 all-column',
      input: false,
      type: 'file',
    },
  ]" :modelName="'addedCompetencies'" :isRequired="false" :mutationName="'k3lStore/SET_K3L_FORM'"
        :storeName="'k3lStore'" :modalName="'modal_add_competencies'" :operationAdd="'skill_add'"
        :editMutation="'k3lStore/SET_SERTIFIKAT_KARYAWAN'" :disabled="$store.state.k3lStore.is_sipm_approved" />
      <notes :items="[
        '<strong>*Catatan</strong>',
        '1. <strong>Kompetensi Umum -</strong> Sertifikasi pekerjaan yang membutuhkan pelatihan dan penguasaan terhadap suatu pengetahuan/keahlian umum yang tidak berdampak kepada kejadian LTI & fatality.',
        '2. Contoh Dokumen Pendukung/Sertifikasi <strong>Kompetensi Umum</strong> K3 (AK3 Umum/POP) - AK3 Umum/POP/ISM Code/sertifikat K3 lainnya.',
        '3. <strong>Kompetensi Khusus -</strong> Sertifikasi pekerjaan yang membutuhkan pelatihan dan penguasaan terhadap suatu pengetahuan/keahlian khusus yang dapat berdampak kepada kejadian LTI & fatality.',
        '4. Contoh Dokumen Pendukung/Sertifikasi <strong>Kompetensi Khusus</strong> (POP/POU) sesuai bidang kerja - Welder, SIO alat angkat, SIO riger, Scafolder, AK3 Listrik, KIM, dll.',
        '5. <strong>Pengalaman Kerja -</strong> Penjelasan Umum Pengalaman Kerja Sebelumnya, Rata-rata Jumlah Tahun Pengalaman',
      ]" />
    </div>

    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goNext()" href="" class="btn-landing">
        Simpan dan Lanjutkan
      </div>
    </div>
  </div>
</template>

<script>
import InputDoc from '../../components/forms/input-doc.vue'
import InputSelectTable from '../../components/forms/input-select-table.vue'
import InputFillForm from '../../components/forms/input-fill-form.vue'
import InputUpload from '../../components/forms/input-upload.vue'
import Notes from '../../components/layout/notes.vue'
export default {
  components: {
    InputDoc,
    InputSelectTable,
    InputFillForm,
    InputUpload,
    Notes,
  },
  data() {
    return {}
  },
  methods: {
    goBack() {
      this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'profile' })
    },
    goNext() {
      this.$store.commit('k3lStore/SAVE_DRAFT_VENDOR_INPUT', {
        onSuccess: () => {
          this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'grup13' })
        }
      })
    },
  },
}
</script>
<style scoped>
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-body {
  display: flex;
  flex-direction: column;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
